import React from "react"
import { cn } from "./cn"

// Tailwind replacement for react-bootstrap <Table>. The app's global table
// styling lives in scss/_global.scss (uppercase headers, row dividers, hover
// cursor) and is preserved, so this is a thin, full-width wrapper.
export default function Table({ className = "", responsive = false, children, ...props }) {
  const table = (
    <table className={cn("w-full", className)} {...props}>
      {children}
    </table>
  )
  if (responsive) {
    return <div className="overflow-x-auto">{table}</div>
  }
  return table
}
